<mat-toolbar color="primary">
  <a id="112-logo" mat-button [routerLink]="['/']"
    ><img src="assets/112.png"
  /></a>
  <span class="fill-space-between"></span>
  <button
    color="accent"
    *ngIf="state.user"
    matTooltip="Útskráning"
    mat-icon-button
    (click)="logout()"
  >
    <mat-icon>logout</mat-icon>
  </button>
  <a
    color="accent"
    *ngIf="
      state.user && (state.user.accessKeys || []).includes('CertificateAdmin')
    "
    mat-icon-button
    [routerLink]="['/admin']"
    matTooltip="Umsjónarsíða - útgáfa 1.1.1"
  >
    <mat-icon>admin_panel_settings</mat-icon>
  </a>
  <a
    id="samsyn-logo"
    mat-button
    href="https://samsyn.is"
    target="_blank"
    matTooltip="Þróað af Samsýn"
    ><img src="assets/samsyn.png"
  /></a>
</mat-toolbar>
<div class="container">
  <router-outlet></router-outlet>
</div>
